export default __webpack_public_path__ + "static/mc-e903571cc5ec24fcfe9c7e6e65669372.svg";